/*
https://github.com/themesberg/flowbite-icons
Flowbite Icons is free and open-source under the MIT License.
*/
import React from 'react';

interface Props {
    readonly className?: string;
}

export default function UserSolid({
    className = null,
}: Props) {
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17317C0.00433284 8.00043 -0.193701 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8079C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C19.9971 7.34873 18.9426 4.80688 17.0679 2.93215C15.1931 1.05742 12.6513 0.0029116 10 0ZM10 5C10.5933 5 11.1734 5.17595 11.6667 5.50559C12.1601 5.83524 12.5446 6.30377 12.7716 6.85195C12.9987 7.40013 13.0581 8.00333 12.9424 8.58527C12.8266 9.16721 12.5409 9.70176 12.1213 10.1213C11.7018 10.5409 11.1672 10.8266 10.5853 10.9424C10.0033 11.0581 9.40013 10.9987 8.85195 10.7716C8.30378 10.5446 7.83524 10.1601 7.5056 9.66671C7.17595 9.17336 7 8.59334 7 8C7 7.20435 7.31607 6.44129 7.87868 5.87868C8.44129 5.31607 9.20436 5 10 5ZM10 18C8.23921 18.0019 6.51699 17.4843 5.049 16.512C5.16502 15.5451 5.63092 14.6541 6.35879 14.0071C7.08666 13.3601 8.02615 13.0019 9 13H11C11.9739 13.0019 12.9134 13.3601 13.6412 14.0071C14.3691 14.6541 14.835 15.5451 14.951 16.512C13.483 17.4843 11.7608 18.0019 10 18Z" fill="currentColor" />
        </svg>
    );
}
